export default __webpack_public_path__ + "static/media/Level-Creation-Template-Site.71082d7f.xlsx";